module.exports = __webpack_public_path__ + "9c1e3adb696ebf4410a70572d49bfc9c.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/7.png
// module id = 305
// module chunks = 0